import { render } from "./course.html?vue&type=template&id=c6cb0682&external"
import script from "./course.js?vue&type=script&lang=js&external"
export * from "./course.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__